import styled from 'styled-components';

export const DashboardContainer = styled.div`
  width: 100%;
  max-width: 945px;
  padding: 40px;
  min-height: 100vh;
`;

export const TopSection = styled.div`
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  gap: 30px;
  margin-bottom: 40px;
  background: white;
  padding: 40px 30px;
  border-radius: 24px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
`;

export const MetricCard = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const MetricLabel = styled.h2`
  font-size: 32px;
  font-weight: 700;
  color: #333333;
  margin: 0;
  line-height: 1.2;
`;

export const MetricValue = styled.div`
  color: ${props => props.theme.colors.primary};
  font-size: 72px;
  margin-top: 40px;
  line-height: 1;
`;

export const ChartContainer = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const CircleChart = styled.div`
  position: relative;
  width: 280px;
  height: 280px;
`;

export const CircleSvg = styled.svg`
  transform: rotate(-90deg);
`;

export const CircleBackground = styled.circle`
  fill: none;
  stroke: #e2e8f0;
  stroke-width: 21;
`;

export const CircleProgress = styled.circle`
  fill: none;
  stroke: ${props => props.theme.colors.primary};
  stroke-width: 21;
  transition: stroke-dashoffset 1s ease-in-out;
`;

export const ChartText = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
`;

export const PercentageValue = styled.div`
  color: #333333;
  font-size: 80px;
  line-height: 1;
`;

export const PercentageLabel = styled.div`
  font-size: 14px;
  color: #797979;
  margin-top: 8px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
`;

export const NewSubscriptionsCard = styled(MetricCard)`
  align-items: flex-end;
  text-align: right;
`;

export const SubMetric = styled.div`
  margin-top: 10px;
`;

export const SubLabel = styled.div`
  font-size: 22px;
  color: #AAA7A9;
  font-weight: 400;
  text-transform: uppercase;
  letter-spacing: 0.5px;
`;

export const SubValue = styled.div`
  font-size: 48px;
  font-weight: 400;
  color: #9EA0A1;
  line-height: 1;

  &.primary {
    color: ${props => props.theme.colors.primary};
    font-size: 72px;
  }
`;

export const BottomSection = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 24px;
`;

export const StatCard = styled.div`
  background: white;
  padding: 35px 30px;
  border-radius: 24px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
`;

export const StatLabel = styled.h3`
  font-size: 32px;
  font-weight: 700;
  color: #333333;
  margin: 0 0 24px 0;
`;

export const StatValue = styled.div`
  font-size: 64px;
  color: #333333;
  line-height: 1;
`;

